 import pro1 from "../assets/project5.jpg"
 import pro2 from "../assets/project3.png"
 import pro3 from "../assets/project4.jpg"
const ProjectCardData=[
    {
        imgsrc: pro1,
        title:" Social media dashboard",
        text:"Dahboard Theme change adjustable for user preferences.Daniel inspires a grounded tangible and self-affirming sense of WOW AMAZING  ", 
        view:"https://dashboard-remake.netlify.app/",
        source:"https://unsplash.com/",
    },
    {
        imgsrc: pro2,
        title:" Time Tracking dashboard",
        text:"Time tracking component adjustable for user preferences.Daniel inspires a grounded tangible and self-affirming sense of WOW AMAZING  ", 
        view:"https://dashboard-remake.netlify.app/",
        source:"https://unsplash.com/",
    },
    {
        imgsrc: pro3,
        title:" E-commerce Website",
        text:"Get BUY & VIEW items for personal use or external use.Shop online for wears and accessories.And support us  ", 
        view:"https://dans-ecommerce.netlify.app/",
        source:"https://unsplash.com/",
    },
    // {
    //     imgsrc: pro3,
    //     title:" Social media dashboard",
    //     text:"Dahboard Theme change adjustable for user preferences.Daniel inspires a grounded tangible and self-affirming sense of  ", 
    //     view:"https://www.dashboard-remake.netlify.app",
    //     source:"unsplash.com",
    // }
]
export default ProjectCardData